// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1a4LR","col":"styles_col__mPEJ3"};